import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavApiByZapier = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M9 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      clipRule="evenodd"
    />
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M19.68 1.005A3.5 3.5 0 0 1 23 4.5l-.005.18a3.5 3.5 0 0 1-3.315 3.315L19.5 8a3.483 3.483 0 0 1-2.122-.718l-1.347.899A7.963 7.963 0 0 1 17 12a7.963 7.963 0 0 1-.97 3.818l1.348.899a3.5 3.5 0 1 1-1.18 1.617l-1.338-.892a8 8 0 1 1 0-10.885l1.34-.892A3.495 3.495 0 0 1 16 4.5l.005-.18A3.5 3.5 0 0 1 19.5 1l.18.005ZM19.5 18a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9 6a6 6 0 1 0 0 12A6 6 0 0 0 9 6Zm10.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavApiByZapier;
